// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../../graphql/api/index';

import { gql } from 'graphql-tag';
import { ImageLargeFragmentDoc } from '../imageLarge.fragment.generated';
export const ComponentBannerTitleFragmentDoc = gql`
    fragment componentBannerTitle on ComponentBannerTitle {
  image {
    ...imageLarge
  }
  date
  bannerTitle: title
  description
  tag
}
    ${ImageLargeFragmentDoc}`;